import React from "react";
import { Typography } from "@mui/material";

import { StyledHubTableTemplate, StyledStack, StyledSubStack } from "./styles";
import { items, keys } from "./helper";
import { useGetWorkOrderRoutingData } from "../../hooks";

export const WorkOrderRoutingDataTable = ({ item, open }) => {
  if (!item.id) return <></>;
  const { data } = useGetWorkOrderRoutingData(
    open && (item.woNumber || item.workOrder)
  );

  const headerProps = { items };
  const bodyProps = { items: data, keys, includeChevron: true };
  const props = { headerProps, bodyProps };

  return (
    <StyledSubStack>
      <StyledStack>
        <Typography variant="boldCaption" margin="5px">
          Routing
        </Typography>
        <StyledHubTableTemplate id="LineItemsTable" {...props} />
      </StyledStack>
    </StyledSubStack>
  );
};

export default WorkOrderRoutingDataTable;
